/* eslint-disable camelcase */
// Partial copypaste of the theme from Glue OS
import { createTheme } from '@material-ui/core/styles'

import { tablet as GlueButtonTablet, web as GlueButtonWeb } from '../theme/glue-button'
import { tablet as IconTablet, web as IconWeb } from '../theme/icon'
import { tablet as GlueScrollTablet, web as GlueScrollWeb } from '../theme/glue-scroll'
import { tablet as GlueDropdownTablet, web as GlueDropdownWeb } from '../theme/glue-dropdown'
import { tablet as GlueListItemTablet, web as GlueListItemWeb } from '../theme/glue-list-item'
import { tablet as GeneralDialogTablet, web as GeneralDialogWeb } from '../theme/general-dialog-template'
import { tablet as LoadingIndicatorTablet, web as LoadingIndicatorWeb } from '../theme/loading-indicator'
import { tablet as OrgIconTablet, web as OrgIconWeb } from '../theme/org-icon'
import { tablet as InputFieldTablet, web as InputFieldWeb } from '../theme/input-field'
import { tablet as LoginPageTablet, web as LoginPageWeb } from '../theme/login-page-template'
import { tablet as OrgAccordionTablet, web as OrgAccordionWeb } from '../theme/org-accordion'
import { tablet as OrgCreatedDialogTablet, web as OrgCreatedDialogWeb } from '../theme/org-created-dialog'

// import SourceSansProSemiBoldFont from '../font/SourceSansPro-SemiBold.ttf'
// import SourceSansProBoldFont from '../font/SourceSansPro-Bold.ttf'
// import SourceSansProRegularFont from '../font/SourceSansPro-Regular.ttf'

const sourceSansPro_Regular = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `url('https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-fonts/SourceSansPro-Regular.ttf') format('truetype')`
}

const sourceSansPro_SemiBold = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 600,
  src: `url('https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-fonts/SourceSansPro-SemiBold.ttf') format('truetype')`
}

const sourceSansPro_Bold = {
  fontFamily: 'Source Sans Pro',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `url('https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-fonts/SourceSansPro-Bold.ttf') format('truetype')`
}

const paletteCommon = {
  // Greys
  white: '#fff',
  grey50: '#f7f9fa',
  grey100: '#ebeef0',
  grey200: '#d5dade',
  grey300: '#c2c6cc',
  grey400: '#a9adb3',
  grey500: '#969a9e',
  grey600: '#83898f',
  grey700: '#63686e',
  grey800: '#454b52',
  grey900: '#383c42',
  grey950: '#292e33',
  black: '#000',

  // Blues
  blue50: '#ebf6ff',
  blue100: '#d9eeff',
  blue200: '#c2e4ff',
  blue300: '#a6d8ff',
  blue400: '#54b5ff',
  blue500: '#54b5ff',
  blue600: '#2e9df2',
  blue700: '#0082e6',
  blue800: '#0062b0',
  blue900: '#004880',
  blue950: '#003259',

  // Purples
  purple50: '#f3edff',
  purple100: '#e6d9ff',
  purple200: '#d8c4ff',
  purple300: '#c9adff',
  purple400: '#b791ff',
  purple500: '#a375ff',
  purple600: '#865dd9',
  purple700: '#6a47b3',
  purple800: '#523494',
  purple900: '#402578',
  purple950: '#2d1a54',

  // Reds
  red100: '#ffe6e8',
  red500: '#d9363b',
  red900: '#4a0c11',

  // Greens
  green50: '#e6fff3',
  green100: '#c2f2db',
  green200: '#8de0b8',
  green300: '#59d499',
  green400: '#34c27f',
  green500: '#09b363',
  green600: '#0a9453',
  green700: '#047a42',
  green800: '#026637',
  green900: '#00542e',
  green950: '#003b20',

  // Yellows
  yellow50: '#fff8e6',
  yellow100: '#fff1c9',
  yellow200: '#ffe7a6',
  yellow300: '#ffdd80',
  yellow400: '#f7cd56',
  yellow500: '#e6b837',
  yellow600: '#cc9f24',
  yellow700: '#ab851b',
  yellow800: '#806210',
  yellow900: '#594304',
  yellow950: '#402f00',

  // Oranges
  orange500: '#e9551c',

  success: '#00ff84',
  alert: '#fcc21f',
  error: '#ff1a30'
}

const palette = {
  type: 'dark',

  // Primary as in 'primary button' but I won't change the name now
  primary: {
    main: paletteCommon.blue700,
    active: paletteCommon.white,
    contrastText: paletteCommon.white,
    textActive: paletteCommon.blue700
  },

  google: {
    main: paletteCommon.white,
    contrastText: paletteCommon.black
  },

  orange: {
    main: '#D63500',
    active: paletteCommon.white,
    contrastText: paletteCommon.white,
    textActive: '#D63500'
  },

  secondary: {
    main: paletteCommon.grey800,
    active: paletteCommon.white,
    hover: 'rgba(255, 255, 255, 0.07)',
    onClick: 'rgba(255, 255, 255, 0.2)',
    contrastText: paletteCommon.white,
    textActive: paletteCommon.blue700
  },

  destructive: {
    main: paletteCommon.red500,
    active: paletteCommon.white,
    contrastText: paletteCommon.white,
    textActive: paletteCommon.red500
  },

  dropdown: {
    main: paletteCommon.grey800,
    active: paletteCommon.grey700,
    hover: 'rgba(255, 255, 255, 0.07)',
    contrastText: paletteCommon.white,
    textActive: paletteCommon.white,
    textHover: paletteCommon.white
  },

  alert: {
    main: paletteCommon.alert
  },

  orgAccordion: {
    main: paletteCommon.grey900,
    active: paletteCommon.grey800,
    hover: 'rgba(255, 255, 255, 0.07)',
    contrastText: paletteCommon.white,
    textActive: paletteCommon.white,
    textHover: paletteCommon.white
  },

  background: {
    default: paletteCommon.black,
    main: paletteCommon.black,
    paper: paletteCommon.grey950,
    heading: paletteCommon.grey900,
    hover: 'rgba(255, 255, 255, 0.07)',
    error: '#470f1b'
  },

  scroll: {
    main: paletteCommon.grey700
  },

  glueCard: {
    background: `linear-gradient(${paletteCommon.grey950}, ${paletteCommon.grey800})`
  },

  avatarCanvas: {
    background: `radial-gradient(circle closest-side at center, ${paletteCommon.grey800}, ${paletteCommon.black})`
  },

  action: {
    default: '#464c52',
    main: '#464c52',
    active: '#fff',
    text: '#C7C9CB',
    textActive: '#292D33',
    error: '#db1629',
    errorText: '#ffccd1'
  },

  stealth: {
    main: 'none',
    hover: 'rgba(255, 255, 255, 0.07)',
    onClick: 'rgba(255, 255, 255, 0.2)',
    active: 'none',
    contrastText: paletteCommon.white,
    textActive: paletteCommon.white,
    textHover: paletteCommon.white
  },

  link: {
    main: 'none',
    hover: 'rgba(255, 255, 255, 0.07)',
    onClick: 'rgba(255, 255, 255, 0.2)',
    active: 'none',
    contrastText: paletteCommon.blue700,
    textActive: paletteCommon.white,
    textHover: paletteCommon.blue500
  },

  listItem: {
    main: 'none',
    hover: 'rgba(255, 255, 255, 0.07)',
    onClick: 'rgba(255, 255, 255, 0.2)',
    active: 'rgba(255, 255, 255, 0.07)',
    contrastText: 'rgba(255, 255, 255, 0.6)',
    textActive: paletteCommon.white,
    textHover: paletteCommon.white
  },

  warning: {
    main: '#db1629',
    active: '#fff',
    contrastText: '#fff',
    textActive: '#fff'
  },

  toggle: {
    main: '#292D33',
    contrastMain: '#454A52',
    active: '#fff',
    contrastText: '#C7C9CB',
    textActive: '#007EDE'
  },

  speechToggle: {
    main: paletteCommon.grey800,
    active: `radial-gradient(${paletteCommon.alert}, ${paletteCommon.orange500} 90%)`,
    contrastText: paletteCommon.white,
    textActive: paletteCommon.white
  },

  // This name makes no sense
  invertedSpeechToggle: {
    main: '#0E1012',
    active: `radial-gradient(${paletteCommon.alert}, ${paletteCommon.orange500} 90%)`,
    contrastText: paletteCommon.white,
    textActive: paletteCommon.white
  },

  actionToggle: {
    main: '#007EDE',
    active: '#fff',
    contrastText: '#fff',
    textActive: '#007EDE'
  },

  invertedActionToggle: {
    main: '#fff',
    active: '#007EDE',
    contrastText: '#007EDE',
    textActive: '#fff'
  },

  speech: {
    highlight: '#E9551C'
  },

  transform: {
    x: {
      light: '#D52224',
      dark: '#8C1618'
    },
    y: {
      light: '#75A74B',
      dark: '#446629'
    },
    z: {
      light: '#007EDE',
      dark: '#0053A6'
    },
    dragArea: {
      text: '#fff'
    },
    inputField: {
      background: '#0E1012',
      outline: '#808080',
      outlineFocused: '#007EDE',
      outlineProportional: '#fff'
    }
  },

  selfButton: {
    main: paletteCommon.blue900
  },

  highlight: {
    background: paletteCommon.blue950,
    main: paletteCommon.blue800,
    contrastText: paletteCommon.blue200
  },

  input: {
    main: paletteCommon.grey700,
    background: paletteCommon.black,
    error: paletteCommon.error,
    backgroundError: paletteCommon.red900,
    active: paletteCommon.blue500,
    backgroundActive: paletteCommon.blue950,
    valid: paletteCommon.success
  }
}

const spacing = (preset) => {
  switch (preset) {
    case 'xs':
      return '4px'
    case 's':
      return '12px'
    case 'm':
      return '24px'
    case 'l':
      return '36px'
    case 'xl':
      return '48px'
    default:
      return 0
  }
}

const spacingWeb = (preset) => {
  switch (preset) {
    case 'xs':
      return '4px'
    case 's':
      return '8px'
    case 'm':
      return '16px'
    case 'l':
      return '24px'
    case 'xl':
      return '36px'
    default:
      return 0
  }
}

const overrides = {
  MuiCssBaseline: {
    '@global': {
      '@font-face': [sourceSansPro_Regular, sourceSansPro_SemiBold, sourceSansPro_Bold],

      body: {
        fontSize: '24px',
        fontWeight: 400,
        lineHeight: '32px'
      },

      p: {
        margin: 0,
        fontSize: '24px',
        fontWeight: 400,
        lineHeight: '32px'
      },

      h1: {
        margin: 0,
        fontSize: '40px',
        fontWeight: 600,
        lineHeight: '40px'
      },

      h2: {
        margin: 0,
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '32px'
      },

      h3: {
        margin: 0,
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '28px'
      }
    }
  },

  MuiTypography: {
    root: {
      color: paletteCommon.white,
      opacity: '60%'
    },

    h1: {
      margin: 0,
      fontSize: '40px',
      fontWeight: 600,
      lineHeight: '40px'
    },

    h2: {
      margin: 0,
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: '32px'
    },

    h3: {
      margin: 0,
      fontSize: '24px',
      fontWeight: 600,
      lineHeight: '28px'
    },

    overline: {
      fontSize: '18px',
      textTransform: 'uppercase',
      fontWeight: 700,
      letterSpacing: '1px',
      lineHeight: '18px'
    },

    body2: {
      fontWeight: 600,
      fontSize: '28px',
      textTransform: 'none',
      letterSpacing: 'normal',
      lineHeight: '40px'
    }
  },

  MuiInputBase: {
    input: {
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '32px',
      padding: 0
    }
  },

  MuiButtonBase: {
    root: {
      fontFamily: 'Source Sans Pro',
      fontWeight: 600,
      letterSpacing: 0,
      fontSize: '24px',
      lineHeight: '32px',
      background: palette.background.paper,
      color: palette.action.text,
      height: '64px',

      '&>.MuiSvgIcon-root': {
        fontSize: '36px'
      }
    }
  },

  MuiDrawer: {
    paper: {
      minWidth: '325px'
    }
  },

  MuiMenu: {
    paper: {
      minWidth: '180px',
      background: '#454A52'
    }
  },

  MuiMenuItem: {
    root: {
      borderRadius: 0,
      textTransform: 'none',
      letterSpacing: 0,
      background: 'none',

      paddingLeft: '24px',
      paddingRight: '24px',

      display: 'flex',
      justifyContent: 'space-between',

      '&:last-child': {
        borderBottom: 0
      },

      '&>.MuiSvgIcon-root': {
        marginLeft: '24px',
        fontSize: '24px'
      }
    }
  },

  MuiDialog: {
    paper: {
      padding: '12px'
    }
  },

  MuiDialogTitle: {
    root: {
      padding: 0,
      textAlign: 'center'
    }
  },

  MuiDialogContent: {
    root: {
      margin: '24px 0 0 0',
      padding: 0
    }
  },

  MuiDialogContentText: {
    root: {
      textAlign: 'center'
    }
  },

  MuiDialogActions: {
    root: {
      marginTop: '36px',
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'center',
      padding: 0
    }
  },

  MuiPaper: {
    rounded: {
      borderRadius: '44px'
    }
  },

  MuiSvgIcon: {
    root: {
      fontSize: '32px'
    }
  },

  MuiIconButton: {
    root: {
      width: '64px',
      height: '64px'
    }
  },

  MuiSnackbarContent: {
    root: {
      backgroundColor: '#D5DADE',
      height: '48px',
      boxShadow: '0 5px 10px rgba(0,0,0,0.75)',

      '& .MuiSnackbarContent-message': {
        padding: 0
      }
    }

  },

  MuiTooltip: {
    tooltip: {
      color: 'black',
      backgroundColor: '#D5DADE',
      height: '48px',
      fontSize: '24px',
      maxWidth: 'none',
      padding: '6px 24px',
      top: '7px',
      boxShadow: '0 5px 10px rgba(0,0,0,0.75)'
    },

    arrow: {
      color: '#D5DADE'
    }

  },

  MuiCheckbox: {
    root: {
      height: '36px',
      with: '36px',

      '&:hover': {
        backgroundColor: 'transparent',
        filter: 'brightness(1.5)'
      }
    },

    colorSecondary: {
      color: '#808080',
      '&$checked': {
        color: palette.toggle.active,
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '& .MuiIconButton-label': {
          position: 'relative',
          zIndex: 0
        },
        '& .MuiIconButton-label:after': {
          content: '""',
          left: '8px',
          height: '30px',
          width: '30px',
          position: 'absolute',
          background: palette.toggle.textActive,
          zIndex: -1
        }
      }
    }
  }
}

const overridesWeb = {
  MuiCssBaseline: {
    '@global': {
      '@font-face': [sourceSansPro_Regular, sourceSansPro_SemiBold, sourceSansPro_Bold],

      body: {
        fontSize: '16px',
        fontWeight: 400,
        userSelect: 'text',
        lineHeight: '24px'
      },

      p: {
        margin: 0,
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px'
      },

      h1: {
        margin: 0,
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '32px'
      },

      h2: {
        margin: 0,
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '24px'
      },

      h3: {
        margin: 0,
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '16px'
      }
    }
  },

  MuiTypography: {
    root: {
      color: paletteCommon.white,
      opacity: '60%'
    },

    h1: {
      margin: 0,
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: '32px',
      letterSpacing: '-0.025em'
    },

    h2: {
      margin: 0,
      fontSize: '24px',
      fontWeight: 600,
      lineHeight: '24px',
      letterSpacing: '-0.025em'
    },

    h3: {
      margin: 0,
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '16px',
      letterSpacing: '-0.01em'
    },

    overline: {
      fontSize: '14px',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      fontWeight: 700,
      lineHeight: '14px'
    },

    body2: {
      fontWeight: 400,
      fontSize: '20px',
      textTransform: 'none',
      lineHeight: '32px',
      letterSpacing: '-0.01em'
    }
  },

  MuiInputBase: {
    input: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      padding: 0
    }
  },

  MuiButtonBase: {
    root: {
      fontFamily: 'Source Sans Pro',
      fontWeight: 600,
      letterSpacing: '0px',
      fontSize: '16px',
      lineHeight: '24px',
      background: palette.secondary.main,
      color: palette.action.text,
      height: '36px',

      '&>.MuiSvgIcon-root': {
        fontSize: '20px'
      }
    }
  },

  MuiDrawer: {
    paper: {
      minWidth: '225px'
    }
  },

  MuiMenu: {
    paper: {
      minWidth: '100px',
      background: '#454A52'
    }
  },

  MuiMenuItem: {
    root: {
      borderRadius: 0,
      textTransform: 'none',
      letterSpacing: 0,
      background: 'none',

      paddingLeft: '24px',
      paddingRight: '24px',

      display: 'flex',
      justifyContent: 'space-between',

      '&:last-child': {
        borderBottom: 0
      },

      '&>.MuiSvgIcon-root': {
        marginLeft: '24px',
        fontSize: '12px'
      }
    }
  },

  MuiDialog: {
    paper: {
      padding: '8px',
      borderRadius: '24px'
    }
  },

  MuiDialogTitle: {
    root: {
      padding: 0,
      textAlign: 'center'
    }
  },

  MuiDialogContent: {
    root: {
      margin: '12px 0 0 0',
      padding: 0
    }
  },

  MuiDialogContentText: {
    root: {
      textAlign: 'center'
    }
  },

  MuiDialogActions: {
    root: {
      marginTop: '36px',
      padding: 0,
      justifyContent: 'center'
    },
    spacing: {
      '& > :not(:first-child)': {
        marginLeft: '0px'
      }
    }
  },

  MuiPaper: {
    rounded: {
      borderRadius: '26px'
    }
  },

  MuiGlueSwitchSelector: {
    root: {
      gridTemplateColumns: '1fr 36px 1fr',
      gap: '18px',

      '& p': {
        fontSize: '16px',
        fontWeight: '600',
        letterSpacing: '0',
        lineHeight: '20px'
      }
    },

    switchRoot: {
      width: '36px',
      height: '18px',
      '& .Mui-checked': {
        transform: 'translateX(18px)'
      }
    },

    switchBase: {
      padding: '2px',
      width: '18px',
      height: '18px'
    },

    thumb: {
      width: '14px',
      height: '14px'
    }
  },

  MuiGlueSliderSelector: {
    thumb: {
      width: '18px',
      height: '18px',

      '& img': {
        width: '36px',
        height: '36px'
      }
    },

    rail: {
      height: '18px'
    }
  },

  MuiGlueAvatarOverview: {
    nameInput: {
      justifyContent: '',
      gap: '18px',

      '& .MuiGlueInputField-searchfield': {
        width: '452px',
        height: '64px',
        borderRadius: '18px',
        borderWidth: '0'
      },

      '& input': {
        fontSize: '42px',
        letterSpacing: '-20'
      }
    },

    nameGuide: {
      fontSize: '16px',
      fontWeight: '400',
      letterSpacing: '0',
      lineHeight: '20px',
      opacity: '70%'
    }
  },

  MuiCheckbox: {
    root: {
      height: '36px',
      with: '36px',

      '&:hover': {
        backgroundColor: 'transparent',
        filter: 'brightness(1.5)'
      }
    },

    colorSecondary: {
      color: '#808080',
      '&$checked': {
        color: palette.toggle.active,
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '& .MuiIconButton-label': {
          position: 'relative',
          zIndex: 0
        },
        '& .MuiIconButton-label:after': {
          content: '""',
          left: 1,
          top: 4,
          height: '16px',
          width: '16px',
          position: 'absolute',
          background: palette.toggle.textActive,
          zIndex: -1
        }
      }
    }
  },

  MuiIconButton: {
    root: {
      width: '36px',
      height: '36px',
      padding: '2px'
    }
  },

  MuiSvgIcon: {
    root: {
      fontSize: '24px'
    }
  },

  MuiSnackbarContent: {
    root: {
      backgroundColor: '#D5DADE',
      height: '36px',
      boxShadow: '0 5px 10px rgba(0,0,0,0.75)',

      '& .MuiSnackbarContent-message': {
        padding: 0
      }
    }

  },

  MuiTooltip: {
    tooltip: {
      color: 'black',
      backgroundColor: '#D5DADE',
      height: '36px',
      fontSize: '16px',
      maxWidth: 'none',
      padding: '6px 16px',
      top: '7px',
      boxShadow: '0 5px 10px rgba(0,0,0,0.75)'
    },

    arrow: {
      color: '#D5DADE'
    }

  }

}

const typography =
{
  fontFamily: 'Source Sans Pro',
  fontWeightRegular: 400,
  fontWeightBold: 700,
  fontSize: 24
}

const typographyWeb =
{
  fontFamily: ['Source Sans Pro', 'sans-serif'].join(','),
  fontWeightRegular: 400,
  fontWeightBold: 700,
  fontSize: 24
}

const glueOSTheme = createTheme({
  overrides: overrides,
  palette: palette,
  typography: typography,
  spacing: spacing,
  custom: {
    glueButton: GlueButtonTablet,
    icon: IconTablet,
    glueScroll: GlueScrollTablet,
    glueDropdown: GlueDropdownTablet,
    glueListItem: GlueListItemTablet,
    errorDialog: GeneralDialogTablet,
    loadingIndicator: LoadingIndicatorTablet,
    orgIcon: OrgIconTablet,
    inputField: InputFieldTablet,
    loginPageTemplate: LoginPageTablet,
    orgAccordion: OrgAccordionTablet,
    orgCreatedDialog: OrgCreatedDialogTablet
  }
})

const webTheme = createTheme({
  overrides: overridesWeb,
  palette: palette,
  typography: typographyWeb,
  spacing: spacingWeb,
  custom: {
    glueButton: GlueButtonWeb,
    icon: IconWeb,
    glueScroll: GlueScrollWeb,
    glueDropdown: GlueDropdownWeb,
    glueListItem: GlueListItemWeb,
    errorDialog: GeneralDialogWeb,
    loadingIndicator: LoadingIndicatorWeb,
    orgIcon: OrgIconWeb,
    inputField: InputFieldWeb,
    loginPageTemplate: LoginPageWeb,
    orgAccordion: OrgAccordionWeb,
    orgCreatedDialog: OrgCreatedDialogWeb
  }
})

export const GlueOSTheme = glueOSTheme
export const WebTheme = webTheme
